module.exports = __webpack_public_path__ + "img/icon_calendar_month.22420551.svg";